import { GEMINI_URL } from '@/src/constants/endpoints';

export const redirectToQS = (
  accountId: string | null | undefined,
  customerId: string | null | undefined,
) => {
  const moveInUrl = `${GEMINI_URL}/journey/tuwy?utm_source=ovo-account-web&utm_medium=web&utm_campaign=Take us with you&accountId=${accountId}&customerId=${customerId}`;
  window.location.replace(moveInUrl);
};
